import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { SearchIcon } from '@chakra-ui/icons';
import { HiOutlineEye } from 'react-icons/hi';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Card,
  CardBody,
  Code,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  Stat,
  StatHelpText,
  StatLabel,
  StatNumber,
  Table,
  TableContainer,
  Tag,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
  VStack,
  Checkbox,
  Drawer,
  DrawerContent,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerFooter,
} from '@chakra-ui/react';
import { ChatMessageType } from '@reclaim-developer-experience/dev-tool-client-sdk/dist';
import UserAgent from 'user-agents';
import { getWebClient } from '../../../../lib/client';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { resetMobileClient } from '../../../../redux/providerBuilder/mobileClient';
import {
  getAllNetworkRequest,
  getPagesVisted,
} from '../../../../redux/providerBuilder/networkRequestStore/selectors';
import {
  resetProviderDetails,
  updateProviderDetails,
} from '../../../../redux/providerBuilder/providerDetails';
import { getProviderDetails } from '../../../../redux/providerBuilder/providerDetails/selectors';
import { resetSelectedInstances, resetSelectedInstancesForRequest } from '../../../../redux/providerBuilder/selectedInstances';
import { setSelectedNetworkRequest } from '../../../../redux/providerBuilder/selectedNetworkRequest';
import { getSelectedNetworkRequest } from '../../../../redux/providerBuilder/selectedNetworkRequest/selectors';
import { updateActiveStep } from '../../../../redux/providerBuilder/stepperDetails';
import { getSessionId } from '../../../../redux/session/selectors';
import { domainIssues } from '../../../../utils/domain-issue';
import { isJSONParsable } from '../../../../utils/is-json-parsable';
import { sortByContentType } from '../../../../utils/manual-verification-session/filter-requests';
import { getUniqueItems } from '../../../../utils/provider-builder/instance-selection-utils';
import { extractDomain } from '../../../../utils/provider-builder/proof-card-utils';
import { seperateURLComponents } from '../../../../utils/provider-builder/request-config-utils';
import JsonView from 'react18-json-view';
import 'react18-json-view/src/style.css';

interface SelectRequestProps {
  setActiveStepInnerForm: (value: any) => void;
  setSearchQueryInput: (value: string) => void;
  searchQueryInput: string;
  accessToken: string;
}

export const SelectRequest = (props: SelectRequestProps) => {
  const dispatch = useAppDispatch();
  const toast = useToast();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isEdit = searchParams.get('isEdit');

  const goBackBtnRef = useRef(null);

  const pagesVisited = useAppSelector(getPagesVisted);
  const networkRequests = useAppSelector(getAllNetworkRequest);
  const selectedNetworkRequest = useAppSelector(getSelectedNetworkRequest);
  const sessionId = useAppSelector(getSessionId);

  const { setActiveStepInnerForm, setSearchQueryInput, searchQueryInput, accessToken } =
    props;
  const [buttonLoading, setButtonLoading] = useState(false);
  const [filteredNetworkRequestStore, setFilteredNetworkRequestStore] = useState<any>([
    ...networkRequests,
  ]);
  const [defaultUserAgent, setDefaultUserAgent] = useState<any[]>([]);
  const [userAgent, setUserAgent] = useState('');
  const [hasShownToast, setHasShownToast] = useState({});
  const [selectedRequests, setSelectedRequests] = useState<any[]>([
    ...(selectedNetworkRequest ?? []),
  ]);
  const [isRequestPreviewDrawerOpen, setIsRequestPreviewDrawerOpen] = useState({
    value: false,
    request: null,
  });

  const {
    isOpen: isGoBackAlertOpen,
    onOpen: onOpenGoBackAlert,
    onClose: onCloseGoBackAlert,
  } = useDisclosure();

  useEffect(() => {
    if (isEdit) {
      setActiveStepInnerForm(1);
    }
  }, [isEdit]);

  useEffect(() => {
    handleSearch(searchQueryInput);
  }, [networkRequests]);

  useEffect(() => {
    getDefaultUserAgent();
  }, []);

  useEffect(() => {
    checkForDomainIssues();
  }, [networkRequests]);

  function checkForDomainIssues(): void {
    const tempShownToast: any = { ...hasShownToast };
    const toastToBeShown: any = {};
    networkRequests.forEach((request: any) => {
      const domainName = extractDomain(request?.currentPageUrl);

      if (
        !tempShownToast?.[domainName] &&
        !toastToBeShown?.[domainName] &&
        domainIssues?.[domainName]
      ) {
        toastToBeShown[domainName] = true;
        toast({
          title: `Warning for ${domainName}`,
          description: domainIssues?.[domainName].join(', '),
          status: 'warning',
          duration: 5000,
          isClosable: true,
        });
      }
    });

    setHasShownToast((prev) => ({ ...prev, ...toastToBeShown }));
  }

  function handleSearch(searchString: string): void {
    setSearchQueryInput(searchString);
    if (searchString === '') {
      setFilteredNetworkRequestStore([...networkRequests]);
    } else {
      const filteredRequests = sortByContentType(
        networkRequests.filter((networkReq: any) => {
          return (
            networkReq.url.includes(searchString) ||
            (networkReq.response.body
              ? networkReq.response?.body.includes(searchString)
              : false)
          );
        })
      );
      setFilteredNetworkRequestStore([...filteredRequests]);
    }
  }

  function handleRequestClick(networkRequest: any) {
    const tempNetworkRequest = { ...networkRequest };
    const isRequestBodyJson = tempNetworkRequest?.request?.body?.length
      ? isJSONParsable(tempNetworkRequest?.request?.body)
      : false;
    const isResponseBodyJson = tempNetworkRequest?.response?.body?.length
      ? isJSONParsable(tempNetworkRequest?.response?.body)
      : false;

    console.log('tempNetworkRequest', tempNetworkRequest);
      

    if (tempNetworkRequest?.contentType?.includes('json') && !isResponseBodyJson) {
      tempNetworkRequest['contentType'] = 'text/html';
    }

    tempNetworkRequest['isRequestBodyJson'] = isRequestBodyJson;
    tempNetworkRequest['isResponseBodyJson'] = isResponseBodyJson;

    const isSelected = selectedRequests.some((req) => req.id === tempNetworkRequest.id);
    if (isSelected) {
      const requestIndex = selectedRequests.findIndex((req) => req.id === tempNetworkRequest.id);
      if (requestIndex === -1) {
        console.error('Request found with .some() but not with .findIndex()', tempNetworkRequest);
        return;
      }
      dispatch(resetSelectedInstancesForRequest(requestIndex));
      setSelectedRequests(
        selectedRequests.filter((req) => req.id !== tempNetworkRequest.id)
      );
    } else {
      setSelectedRequests([...selectedRequests, tempNetworkRequest]);
    }
  }

  function handleNext() {
    if (selectedRequests.length > 0) {
      let tempSelectedRequests = [...selectedRequests];
      tempSelectedRequests.forEach((req) => {
        let request = { ...req };
        request.urlSpans = seperateURLComponents(request.url);
        request.templateUrl = request.url;
        request.bodySniff = {
          enabled: !!request.request?.body,
          regex: '',
          template: request.request?.body,
        };
      });
      
      dispatch(setSelectedNetworkRequest(tempSelectedRequests));
      setButtonLoading(true);
      setActiveStepInnerForm(1);
    } else {
      toast({
        title: 'Please select at least one request',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
    }
  }

  function handleGoBack() {
    dispatch(resetMobileClient());
    dispatch(updateActiveStep(0));
  }

  function getDefaultUserAgent() {
    const devices = ['desktop', 'mobile'];
    const allUserAgents: { name: string; value: string }[] = [];
    devices.forEach((device) => {
      const userAgentChrom = new UserAgent([/Chrome/, { deviceCategory: device }]);
      const userAgentSafari = new UserAgent([/Safari/, { deviceCategory: device }]);
      const userAgentMozilla = new UserAgent([/Mozilla/, { deviceCategory: device }]);
      allUserAgents.push({
        name: device + ' - Chrome',
        value: userAgentChrom.toString(),
      });
      allUserAgents.push({
        name: device + ' - Safari',
        value: userAgentSafari.toString(),
      });
      allUserAgents.push({
        name: device + ' - Mozilla',
        value: userAgentMozilla.toString(),
      });
    });
    setDefaultUserAgent(allUserAgents);
  }

  function handleUserAgentChange(value: string) {
    try {
      const client = getWebClient(accessToken);
      client.sendMessage(
        { message: value, type: ChatMessageType.W_SEND_USER_AGENT },
        sessionId
      );
      dispatch(updateProviderDetails({ userAgent: { android: value, ios: value } }));
      setUserAgent(value);
    } catch (error) {
      console.error(error);
    }
  }

  const FormatBody = (data: any) => {
    const { response, contentType } = data?.request;
    const body = response?.body;

    try {
      if (contentType.includes('application/json')) {
        const bodyObj = JSON.parse(body);
        return <JsonView src={bodyObj} collapseStringsAfterLength={70} />;
      } else {
        if (!body?.length) {
          return <Text>Empty Response</Text>;
        }
        return <Text>{body}</Text>;
      }
    } catch (error) {
      return <Text>{body}</Text>;
    }
  };

  return (
    <>
      <Box width="100%" height="100%">
        <VStack h="calc(100vh - 220px)" overflowY="auto" overflowX="hidden">
          <Box w="full" p={7}>
            <Flex>
              <Box flex={0.9}>
                <Heading className="regular-font" mb={2}>
                  Session ID: {sessionId}
                </Heading>
                <Heading className="regular-font" mb={2}>
                  Select one or more URLs for the provider
                </Heading>
                <Text className="small-font" lineHeight="24px" color="#98A2B3">
                  Select the URL(s) containing the data you want to prove. You can select
                  multiple requests if needed.
                </Text>
              </Box>
              <Box flex={1} maxW="700px">
                <Flex gap={5}>
                  <Card variant="outline" flex={1} borderRadius={10} height="fit-content">
                    <CardBody pl={4} pb={2}>
                      <Stat>
                        <StatLabel
                          mb={1}
                          className="medium-font"
                          color="#667085"
                          fontWeight={600}
                        >
                          Pages visited
                        </StatLabel>
                        <StatNumber>
                          <Flex alignItems="center" gap={2}>
                            <Text className="large-font">
                              {getUniqueItems(pagesVisited).length}
                            </Text>
                          </Flex>
                        </StatNumber>
                        <StatHelpText
                          mt={1}
                          fontWeight={400}
                          className="x-small-font"
                          color="gray.600"
                        >
                          Number of unique pages visited
                        </StatHelpText>
                      </Stat>
                    </CardBody>
                  </Card>
                  <Card variant="outline" flex={1} borderRadius={10} height="fit-content">
                    <CardBody pl={4} pb={2}>
                      <Stat>
                        <StatLabel
                          mb={1}
                          className="medium-font"
                          color="#667085"
                          fontWeight={600}
                        >
                          Requests captured
                        </StatLabel>
                        <StatNumber>
                          <Flex alignItems="center" gap={2}>
                            <Text className="large-font">{networkRequests.length}</Text>
                          </Flex>
                        </StatNumber>
                        <StatHelpText
                          mt={1}
                          fontWeight={400}
                          className="x-small-font"
                          color="gray.600"
                        >
                          Number of Requests Captured
                        </StatHelpText>
                      </Stat>
                    </CardBody>
                  </Card>
                </Flex>
              </Box>
            </Flex>
          </Box>
          <Flex w="full" px={6} gap={6}>
            <InputGroup flex={1}>
              <InputRightElement pointerEvents="none">
                <SearchIcon color="gray.300" />
              </InputRightElement>
              <Input
                placeholder="Search for data"
                value={searchQueryInput}
                onChange={(e) => handleSearch(e.target.value)}
                _placeholder={{ color: '#667085' }}
                p={5}
                border="1.5px solid"
                borderColor="gray.50"
                borderRadius={8}
                className="small-font"
              />
            </InputGroup>

            <Select
              flex={0.3}
              placeholder="User Agent"
              value={userAgent}
              onChange={(e) => {
                handleUserAgentChange(e.target.value);
              }}
              borderRadius={8}
              border="1.5px solid"
              borderColor="gray.50"
              className="small-font"
              style={{
                color: 'black',
                backgroundColor: 'transparent',
                padding: '6px 5px',
                paddingLeft: '12px',
                textTransform: 'capitalize',
              }}
            >
              {defaultUserAgent.map((userAgent, index) => {
                return (
                  <option key={index} value={userAgent.value}>
                    {userAgent.name}
                  </option>
                );
              })}
            </Select>
          </Flex>
          <Box
            scrollMarginLeft={10}
            overflow="auto"
            borderWidth={1}
            borderRadius={8}
            w="calc(100% - 50px)"
            border="2px solid"
            borderColor="gray.50"
          >
            <TableContainer>
              <Table
                variant="simple"
                border="ActiveBorder"
                borderRadius="4px"
                borderColor="black"
              >
                <Thead>
                  <Tr>
                    <Th width="50px">
                      <Checkbox
                        borderColor={'gray.600'}
                        isChecked={
                          selectedRequests.length === filteredNetworkRequestStore.length
                        }
                        isIndeterminate={
                          selectedRequests.length > 0 &&
                          selectedRequests.length < filteredNetworkRequestStore.length
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedRequests(filteredNetworkRequestStore);
                          } else {
                            setSelectedRequests([]);
                          }
                        }}
                      />
                    </Th>
                    <Th color="black" fontWeight={600} className="x-small-font">
                      Request URL
                    </Th>
                    <Th />
                    <Th color="black" fontWeight={600} className="x-small-font">
                      Content Type
                    </Th>
                    <Th />
                    {/* <Th color="black" fontWeight={600} className="x-small-font">
                      Request Type
                    </Th> */}
                  </Tr>
                </Thead>
                <Tbody>
                  {filteredNetworkRequestStore?.map((e: any) => (
                    <Tr
                      key={e.id}
                      onClick={() => handleRequestClick(e)}
                      cursor="pointer"
                      sx={{
                        '&:hover:not(:has(td:last-child:hover))': {
                          bg: 'gray.100'
                        }
                      }}
                      bg={
                        selectedRequests.some((req) => req.id === e.id)
                          ? 'gray.200'
                          : 'white'
                      }
                    >
                      <Td width="50px" onClick={(event) => event.stopPropagation()}>
                        <Checkbox
                          borderColor={'gray.600'}
                          isChecked={selectedRequests.some((req) => req.id === e.id)}
                          onChange={() => handleRequestClick(e)}
                        />
                      </Td>


                      <Td
                        maxW="500px"
                        overflow="hidden"
                        whiteSpace="nowrap"
                        textOverflow="ellipsis"
                      >
                        <Text className="small-font" color="black">
                          {e.url}
                        </Text>
                      </Td>
                      <Td style={{ padding: 0 }}>
                        <Flex justifyContent="center">
                          {e?.contentType?.includes('application/json') ? (
                            <Tag
                              borderRadius={15}
                              bgColor="#ECFDF3"
                              border="1.5px solid #ABEFC6"
                              color="#067647"
                              fontWeight={500}
                              px={2}
                              className="small-font"
                            >
                              <Flex gap={1.5} alignItems="center">
                                <span
                                  style={{
                                    display: 'inline-block',
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    backgroundColor: '#17B26A',
                                  }}
                                />
                                Stable
                              </Flex>
                            </Tag>
                          ) : (
                            <Tag
                              borderRadius={15}
                              bgColor="#FFFAEB"
                              border="1.5px solid #FEDF89"
                              color="#B54708"
                              fontWeight={500}
                              px={2}
                              className="small-font"
                            >
                              <Flex gap={1.5} alignItems="center">
                                <span
                                  style={{
                                    display: 'inline-block',
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    backgroundColor: '#F79009',
                                  }}
                                />
                                Beta
                              </Flex>
                            </Tag>
                          )}
                        </Flex>
                      </Td>
                      <Td
                        maxW="200px"
                        overflow="hidden"
                        whiteSpace="nowrap"
                        textOverflow="ellipsis"
                      >
                        <Code
                          backgroundColor="transparent"
                          color="black"
                          className="small-font"
                        >
                          {e.contentType}
                        </Code>
                      </Td>
                      <Td
                        style={{ padding: 0 }}
                        _hover={{ bg: 'gray.300' }}
                        onClick={(event) => {
                          event.stopPropagation();
                          setIsRequestPreviewDrawerOpen({ value: true, request: e });
                        }}
                      >
                        <Flex justifyContent="center">
                          <HiOutlineEye size={20} color="gray" />
                        </Flex>
                      </Td>
                      {/* <Td
                        maxW="200px"
                        overflow="hidden"
                        whiteSpace="nowrap"
                        textOverflow="ellipsis"
                      >
                        <Code
                          backgroundColor="transparent"
                          color="black"
                          className="small-font"
                        >
                          {e.requestType}
                        </Code>
                      </Td> */}
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        </VStack>
        <Box w="full" mt={5} className="bg-secondary" borderRadius={'10'} px={30} py={4}>
          <Flex w="full" justifyContent="space-between">
            <Button
              onClick={onOpenGoBackAlert}
              backgroundColor="transparent"
              border="1px solid gray"
              borderRadius={10}
              fontWeight="normal"
              minWidth={'100px'}
              _hover={{
                backgroundColor: 'gray.100',
              }}
            >
              Back
            </Button>
            <Flex alignItems="center" gap={3}>
              <Text color="gray.500" className="small-font">
                2/7
              </Text>
              <Button
                isLoading={buttonLoading}
                onClick={handleNext}
                backgroundColor="black"
                color="white"
                border="1px solid black"
                borderRadius={10}
                fontWeight="normal"
                minWidth={'100px'}
                isDisabled={selectedRequests.length === 0}
                _hover={{ backgroundColor: 'gray.800' }}
              >
                Next ({selectedRequests.length} selected)
              </Button>
            </Flex>
          </Flex>
        </Box>
        {isGoBackAlertOpen && (
          <AlertDialog
            isOpen={isGoBackAlertOpen}
            leastDestructiveRef={goBackBtnRef}
            onClose={onCloseGoBackAlert}
          >
            <AlertDialogOverlay>
              <AlertDialogContent>
                <AlertDialogCloseButton />
                <AlertDialogHeader className="regular-font" fontWeight="bold">
                  Confirm go back
                </AlertDialogHeader>
                <AlertDialogBody>
                  Are you sure? All saved changes will be lost
                </AlertDialogBody>
                <AlertDialogFooter>
                  <Button
                    colorScheme="blackAlpha"
                    bgColor="black"
                    _hover={{
                      transform: 'scale(1.1)',
                    }}
                    onClick={handleGoBack}
                  >
                    Confirm
                  </Button>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialogOverlay>
          </AlertDialog>
        )}
        {isRequestPreviewDrawerOpen.value && (
          <Drawer
            placement={'right'}
            isOpen={isRequestPreviewDrawerOpen.value}
            onClose={() => setIsRequestPreviewDrawerOpen({ value: false, request: null })}
            size="xl"
          >
            <DrawerOverlay />
            <DrawerContent>
              <DrawerHeader borderBottomWidth="1px">Network Request Preview</DrawerHeader>
              <DrawerBody>
                <FormatBody request={isRequestPreviewDrawerOpen.request} />
              </DrawerBody>
              <DrawerFooter borderTopWidth="1px">
                <Button
                  onClick={() =>
                    setIsRequestPreviewDrawerOpen({ value: false, request: null })
                  }
                  mr={5}
                >
                  Close
                </Button>
                {selectedRequests.some(
                  // @ts-ignore
                  (req: any) => req.id === isRequestPreviewDrawerOpen.request?.id
                ) ? (
                  <Button
                    backgroundColor="black"
                    color="white"
                    borderRadius={10}
                    onClick={() => {
                      handleRequestClick(isRequestPreviewDrawerOpen.request);
                      setIsRequestPreviewDrawerOpen({ value: false, request: null });
                    }}
                  >
                    Remove from provider
                  </Button>
                ) : (
                  <Button
                    backgroundColor="black"
                    color="white"
                    borderRadius={10}
                    onClick={() => {
                      handleRequestClick(isRequestPreviewDrawerOpen.request);
                      setIsRequestPreviewDrawerOpen({ value: false, request: null });
                    }}
                  >
                    Add to provider
                  </Button>
                )}
              </DrawerFooter>
            </DrawerContent>
          </Drawer>
        )}
      </Box>
    </>
  );
};
